var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[(_vm.logJobLists)?_c('LogTemplate',{attrs:{"job":_vm.logJobLists,"patient":_vm.logJobLists.patient,"detail":_vm.logJobLists,"schedules":_vm.logJobLists.schedules}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }